// extracted by mini-css-extract-plugin
export default {"products":"pt-z","card":"qt-z","oosMessaging":"rt-z"};